import { useCallback, useMemo } from 'react';
import { generatePath, useMatch, useNavigate } from 'react-router-dom';
import { getSegmentName } from './usePathSegment.helpers.ts';
import type {
  TPathSegment,
  TPathSegmentValue,
} from './usePathSegment.types.ts';

export const usePathSegment = ({
  path,
  fallbackPath,
}: TPathSegment): TPathSegmentValue => {
  const match = useMatch(path);
  const navigate = useNavigate();

  const name = getSegmentName(path);
  const value = match?.params[name];

  const setValue = useCallback(
    (next?: string) => {
      const nextPath =
        next === undefined
          ? fallbackPath
          : generatePath(path, { [name]: next });

      navigate(nextPath, { replace: true });
    },
    [path, name, fallbackPath, navigate],
  );

  return useMemo(() => ({ value, setValue }), [value, setValue]);
};
